import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoActividad } from 'src/app/app.config/app.config-beneficios';
import { map } from 'rxjs/operators';
import { StorageService } from './shared/storage.service';
import { AuthService } from './auth/auth.service';
import { environment } from '@env/environment';
import Swal from 'sweetalert2';

const URL_BACKEND = environment.urlBackend;

@Injectable({
  providedIn: 'root',
})
export class TipoActividadService {
  
  private categoriaSeleccionada: TipoActividad | null = null;

  constructor(private http: HttpClient, 
    private storageService: StorageService,
    private authService: AuthService,
  ) { }

  // Función que obtiene el token desde localStorage
  private getToken(): string | null {
    return localStorage.getItem('token');
  }

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const token = this.getToken();
    if (token) {
      headers = headers.set('x-token', token); // Establecer el token en el encabezado
    } else {
      console.log('No token found');
    }

    return headers;
  }

  // Método para obtener tipos de actividad
  obtenerTipoActividades(): Observable<TipoActividad[]> {
    return this.http.get<{ response: TipoActividad[] }>(`${URL_BACKEND}/actividad-tipos/findAll`, {
      headers: this.getHeaders(),
    }).pipe(
      map(response => response.response)
    );
  }

  postTipoActividad(data: { nombre: string; descripcion: string }): Observable<any> {
    return this.http.post<any>(URL_BACKEND, data, {
      headers: this.getHeaders(),
    });
  }

  getTipoActividadById(id: string): Observable<TipoActividad> {
    return this.http.get<{ response: TipoActividad }>(`${URL_BACKEND}/actividad-tipos/findOne/${id}`, {
      headers: this.getHeaders(),
    }).pipe(
      map(response => response.response)
    );
  }

  setCategoriaSeleccionada(categoria: TipoActividad): void {
    this.categoriaSeleccionada = categoria;
    this.storageService.setCategoria(categoria);
  }

  getCategoriaSeleccionada(): TipoActividad {
    return this.categoriaSeleccionada;
  }

  updateTipoActividad(id: string, data: { denominacion: string }): Observable<any> {
    return this.http.put<any>(`${URL_BACKEND}/actividad-tipos/updateOne/${id}`, data, {
      headers: this.getHeaders(),
    });
  }
  
  async post(data: TipoActividad): Promise<any> {
    const token = await this.authService.loadJwToken();
    
    const headers = new HttpHeaders({
        'x-token': token
    });

    return new Promise((resolve, reject) => {
        this.http.post<any>(`${URL_BACKEND}/actividad-tipos`, data, { headers }).subscribe({
            next: (resp) => {
                resolve(resp?.response || resp); // Dependiendo de la estructura de respuesta
            },
            error: (error) => {
                console.error('Error al guardar:', error);
                Swal.fire('Error al guardar', '', 'error');
                resolve(false); // O reject(error) si prefieres manejar con catch
            }
        });
    });
  }

  async delete(id: string): Promise<boolean> {
    const token = await this.authService.loadJwToken();
    const headers = new HttpHeaders({
      'x-token': token
    });

    return new Promise(resolve => {
      this.http.delete(`${URL_BACKEND}/actividad-tipos/${id}`, { headers }).subscribe({
        next: () => resolve(true),
        error: (error) => {
          console.error('Error al eliminar categoría:', error);
          resolve(false);
        }
      });
    });
  }

}
